import { render, staticRenderFns } from "./AddReg.vue?vue&type=template&id=74bc337e&scoped=true"
import script from "./AddReg.vue?vue&type=script&lang=js"
export * from "./AddReg.vue?vue&type=script&lang=js"
import style0 from "./AddReg.vue?vue&type=style&index=0&id=74bc337e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc337e",
  null
  
)

export default component.exports